import {
  type MantineStyleProps,
  Text as MantineText,
  type TextProps,
} from "@mantine/core";

type Props = {
  children: React.ReactNode;
} & MantineStyleProps &
  TextProps;

export function Text(props: Props) {
  const { children, ...textProps } = props;
  const defaultOption: TextProps = {
    fz: "md",
  };
  const option = Object.assign({}, defaultOption, textProps);
  return <MantineText {...option}>{children}</MantineText>;
}
